import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

interface UpdateAccountFileVariables {
    formData: FormData;
    documentType: number;
}

const useUpdateAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation<unknown, Error, UpdateAccountFileVariables>({
        mutationFn: ({ formData, documentType }) =>
            documentService.updateAccountFile(formData, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useUpdateAccountFile;
